"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GenerateAds;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _GenerateAdsForm = _interopRequireDefault(require("../../containers/CampaignCreator/GenerateAdsForm"));

var _messageStreams = require("../../reducers/messageStreams");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function GenerateAds(props) {
  var _useSelector = (0, _reactRedux.useSelector)(_messageStreams.messagesSelector),
      sections = _useSelector.sections;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    return state.quadrants;
  }),
      quadrants = _useSelector2.quadrants,
      current = _useSelector2.current;

  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
    return state.messageStreams;
  }),
      personas = _useSelector3.personas;

  var selectedQuadrant = undefined;
  quadrants.forEach(function (quadrant, ix) {
    if (quadrant.id === current) {
      selectedQuadrant = quadrants[ix];
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "generate-ads"
  }, /*#__PURE__*/React.createElement(_GenerateAdsForm["default"], {
    isTestMode: true,
    selectedQuadrant: selectedQuadrant,
    briefSections: sections,
    personas: personas
  }));
}